module.exports = __webpack_public_path__ + "img/54.074c569b.png";